import { Link, type LinkComponentProps } from "@tanstack/react-router";
import { useLang } from "@/i18n/use-lang";

/** Public paths without language prefix, as used in page content. */
export type PublicPath =
  | "/"
  | "/nieuwbouw"
  | "/renovatie"
  | "/technieken"
  | "/warmtepompen-afdekkingen"
  | "/realisaties"
  | "/realisaties/$slug"
  | "/realisaties/gemeente/$gemeente"
  | "/opbouw-zwembad"
  | "/over-ons"
  | "/offerte"
  | "/blog"
  | "/sitemap"
  | "/privacybeleid"
  | "/cookiebeleid"
  | "/blog/$slug";

type LocaleLinkProps = Omit<LinkComponentProps<"a">, "to" | "params"> & {
  to: PublicPath;
  params?: Record<string, string>;
};

/** Link to a public page in the currently active language. */
export function LocaleLink({ to, params, ...rest }: LocaleLinkProps) {
  const lang = useLang();
  const target = to === "/" ? "/$lang" : (`/$lang${to}` as const);
  return <Link {...rest} to={target} params={{ lang, ...params }} />;
}
